// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkout-contact-mail,
.checkout-billing-info {
    color: var(--dPink);
    font-weight: 700;
    font-size: 20px;
    text-transform: uppercase;
    margin-bottom: -5px;
    padding-left: 10px;
}

.cb-input-fields,
.cb-dropdown-field button { 
    padding: 10px !important;
    border: 2px solid var(--cBBlue) !important;
    border-radius: 15px !important;
    line-height: 0px !important;
    font-size: 16px !important;
    height: 40px;
}

.text-area-wrapper textarea{
    border: 2px solid var(--cBBlue) !important;
    border-radius: 15px !important;
}

.cb-dropdown-field button {
    width: 100%;
    background-color: transparent !important;
    background-color: initial !important;
}

/* .cb-dropdown-field button::after {
    content: "⌄" !important;
    position: absolute;
    right: 10%;
    color: #CFCCC2 !important;
    font-size: 18px;
    border: unset !important;
} */

.cb-dropdown-field .dropdown-toggle.btn{
    text-align: left;
}
.cb-dropdown-field .dropdown-toggle::after{
    position: absolute;
    right: 5%;
}

.cb-form-label {
    font-size: 15px;
    font-family: 'Poppins';
    padding-left: 10px;
}

.ph-country-code button {
    background-color: transparent !important;
    background-color: initial !important;
    border-radius: 15px 0px 0px 15px !important;
    border: 2px solid var(--cBBlue) !important;
}

.ph-country-code button:hover {
    color: var(--dBlue);
}

#input-group-dropdown-1:focus-visible {
    color: #000;
}

.ph-no-input-fields {
    border-radius: 0px 15px 15px 0px !important;
}

.cart-payement-pg-btns {
    display: flex;
    justify-content: space-between;
}

.back-to-cart {
    background-color: transparent !important;
    background-color: initial !important;
    color: var(--dPink);
    border: 2px solid var(--cBBlue);
    font-family: 'Poppins';
    font-weight: 600;
    font-size: 18px;
    border-radius: 30px;
    padding: 10px 25px;
}

.go-to-payement {
    background-color: var(--dBlue);
    font-family: 'Poppins';
    font-weight: 600;
    font-size: 18px;
    border-radius: 30px;
    padding: 10px 25px;
}

.all-products-amt {
    background-color: var(--uPTPink);
    border-radius: 30px;
}

.checkout-products {
    padding: 40px 40px 10px 40px;
    border-bottom: 2px solid #FFBCDC;
}

.checkout-pg-product {
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 25px;
}

.product-img-c img {
    height: 80px;
    width: auto;
}

/* 
.product-name-c {
    width: 100%;
} */

.grand-total {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 40px 0px 40px;
}

.total-txt,
.gross-amount {
    padding: 20px 0 20px 50px;
}

.total-txt p {
    color: var(--dPink);
    font-size: 20px;
}

.gross-amount p {
    font-weight: 700;
    font-size: 20px;
}

.back-to-cart:hover {
    color: var(--dPink);
}

.cb-dropdown-field .dropdown-toggle.btn{
    color: #000;
    font-weight: 300;
}

.dropdown-menu{
    max-height: 300px;
    overflow: scroll;
}

.checkout-search-bar{
    width: 95%;
    padding: 5px;
    border-radius: 10px;
    display: block;
    margin: 0 auto;
}

@media (max-width: 767px) {
    .checkout-products {
        padding: 40px 10px 10px 10px;
    }

    .product-img-c img {
        height: 60px;
    }

    .checkout-pg-product {
        column-gap: 10px;
    }

    .ph-country-code button {
        padding: 6px !important;
    }

    .go-to-payement,
    .back-to-cart {
        padding: 10px 15px;
    }

    .grand-total {
        padding: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/component/checkout-page/Checkout.css"],"names":[],"mappings":"AAAA;;IAEI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,wBAAwB;IACxB,0CAA0C;IAC1C,8BAA8B;IAC9B,2BAA2B;IAC3B,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,0CAA0C;IAC1C,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,wCAAkC;IAAlC,oCAAkC;AACtC;;AAEA;;;;;;;GAOG;;AAEH;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,wCAAkC;IAAlC,oCAAkC;IAClC,2CAA2C;IAC3C,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,wCAAkC;IAAlC,oCAAkC;IAClC,mBAAmB;IACnB,+BAA+B;IAC/B,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;;;GAGG;;AAEH;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".checkout-contact-mail,\r\n.checkout-billing-info {\r\n    color: var(--dPink);\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n    text-transform: uppercase;\r\n    margin-bottom: -5px;\r\n    padding-left: 10px;\r\n}\r\n\r\n.cb-input-fields,\r\n.cb-dropdown-field button { \r\n    padding: 10px !important;\r\n    border: 2px solid var(--cBBlue) !important;\r\n    border-radius: 15px !important;\r\n    line-height: 0px !important;\r\n    font-size: 16px !important;\r\n    height: 40px;\r\n}\r\n\r\n.text-area-wrapper textarea{\r\n    border: 2px solid var(--cBBlue) !important;\r\n    border-radius: 15px !important;\r\n}\r\n\r\n.cb-dropdown-field button {\r\n    width: 100%;\r\n    background-color: unset !important;\r\n}\r\n\r\n/* .cb-dropdown-field button::after {\r\n    content: \"⌄\" !important;\r\n    position: absolute;\r\n    right: 10%;\r\n    color: #CFCCC2 !important;\r\n    font-size: 18px;\r\n    border: unset !important;\r\n} */\r\n\r\n.cb-dropdown-field .dropdown-toggle.btn{\r\n    text-align: left;\r\n}\r\n.cb-dropdown-field .dropdown-toggle::after{\r\n    position: absolute;\r\n    right: 5%;\r\n}\r\n\r\n.cb-form-label {\r\n    font-size: 15px;\r\n    font-family: 'Poppins';\r\n    padding-left: 10px;\r\n}\r\n\r\n.ph-country-code button {\r\n    background-color: unset !important;\r\n    border-radius: 15px 0px 0px 15px !important;\r\n    border: 2px solid var(--cBBlue) !important;\r\n}\r\n\r\n.ph-country-code button:hover {\r\n    color: var(--dBlue);\r\n}\r\n\r\n#input-group-dropdown-1:focus-visible {\r\n    color: #000;\r\n}\r\n\r\n.ph-no-input-fields {\r\n    border-radius: 0px 15px 15px 0px !important;\r\n}\r\n\r\n.cart-payement-pg-btns {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.back-to-cart {\r\n    background-color: unset !important;\r\n    color: var(--dPink);\r\n    border: 2px solid var(--cBBlue);\r\n    font-family: 'Poppins';\r\n    font-weight: 600;\r\n    font-size: 18px;\r\n    border-radius: 30px;\r\n    padding: 10px 25px;\r\n}\r\n\r\n.go-to-payement {\r\n    background-color: var(--dBlue);\r\n    font-family: 'Poppins';\r\n    font-weight: 600;\r\n    font-size: 18px;\r\n    border-radius: 30px;\r\n    padding: 10px 25px;\r\n}\r\n\r\n.all-products-amt {\r\n    background-color: var(--uPTPink);\r\n    border-radius: 30px;\r\n}\r\n\r\n.checkout-products {\r\n    padding: 40px 40px 10px 40px;\r\n    border-bottom: 2px solid #FFBCDC;\r\n}\r\n\r\n.checkout-pg-product {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    column-gap: 25px;\r\n}\r\n\r\n.product-img-c img {\r\n    height: 80px;\r\n    width: auto;\r\n}\r\n\r\n/* \r\n.product-name-c {\r\n    width: 100%;\r\n} */\r\n\r\n.grand-total {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 20px 40px 0px 40px;\r\n}\r\n\r\n.total-txt,\r\n.gross-amount {\r\n    padding: 20px 0 20px 50px;\r\n}\r\n\r\n.total-txt p {\r\n    color: var(--dPink);\r\n    font-size: 20px;\r\n}\r\n\r\n.gross-amount p {\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n}\r\n\r\n.back-to-cart:hover {\r\n    color: var(--dPink);\r\n}\r\n\r\n.cb-dropdown-field .dropdown-toggle.btn{\r\n    color: #000;\r\n    font-weight: 300;\r\n}\r\n\r\n.dropdown-menu{\r\n    max-height: 300px;\r\n    overflow: scroll;\r\n}\r\n\r\n.checkout-search-bar{\r\n    width: 95%;\r\n    padding: 5px;\r\n    border-radius: 10px;\r\n    display: block;\r\n    margin: 0 auto;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .checkout-products {\r\n        padding: 40px 10px 10px 10px;\r\n    }\r\n\r\n    .product-img-c img {\r\n        height: 60px;\r\n    }\r\n\r\n    .checkout-pg-product {\r\n        column-gap: 10px;\r\n    }\r\n\r\n    .ph-country-code button {\r\n        padding: 6px !important;\r\n    }\r\n\r\n    .go-to-payement,\r\n    .back-to-cart {\r\n        padding: 10px 15px;\r\n    }\r\n\r\n    .grand-total {\r\n        padding: 10px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
